import { defineComponent, type PropType } from 'vue'
import { ApDialog, ApButton, ApCheckbox, ApMessageBox } from '@anypromo/components-pc'
import { type PriceGroupModel, type PriceSpecLimitation, type PriceGroupCallback, type PriceGroupLocation, type PriceChooseOption, type PriceGroupNameValue } from './types'
import { getMappedMethod } from '../../composables/use-imprint'
import { useOrder } from "../../composables/use-order"
import { OrderType } from '../../types/basic'
import { useWindow } from '../../composables'
import type { SpecGroup } from '../../types'

export default defineComponent({
  name: "PopupPriceGroupSelect",
  components: { ApDialog, ApCheckbox, ApButton },
  props: {
    type: {
      type: String as PropType<PriceChooseOption>,
      default: 'productSpec'
    },
    value: {
      type: Object as PropType<PriceGroupNameValue>,
      default: {} as PriceGroupNameValue
    },
    priceGroupList: {
      type: Array as PropType<PriceGroupModel[]>,
      default: [] as PriceGroupModel[]
    },
    callback: Function as PropType<(data?: PriceGroupCallback) => void>
  },
  emits: ['update:visible', 'cancel', 'confirm'],
  setup (props, { emit, expose }) {
    const orderState = useOrder();

    const onCancel = () => {
      emit('cancel')
    }

    const onConfirm = () => {
      const selectedItem = props.priceGroupList.find(f => f.selected)
      if (!selectedItem) {
        ApMessageBox.alert('Please select one option to continue.', ' ', {
          showClose: false
        })
        return;
      }
      const param: PriceGroupCallback = {
        type: props.type,
        value: props.value,
        selectedItem: selectedItem,
        updateBlankValue: false,// props.displayMsg === 'message'
        changedStep: {
          productSpec: false,
          spec: false,
          addon: false,
          imprintMethod: false
        }
      }
      if (props.callback) {
        props.callback(param)
      }
      emit('confirm', param)
    }

    const renderButtons = () => (
      <div class="price-group__btns">
        <ap-button type="primary" size="small" onClick={onConfirm}>OK</ap-button>
        <ap-button type="default" size="small" onClick={onCancel}>Cancel</ap-button>
      </div>)

    const renderSpecLimitation = (values: PriceSpecLimitation[]) => values.map(item => {
      const { specList, addonList } = useWindow()
      let specName = item.name
       let values: {
        value: string,
        text: string
      }[] = []

      const foundSpec = specList.some((sp) => {
        if (sp.name === item.name) {
          specName = sp.text
          item.values.map((val) => {
            const it = sp.values.find((v) => v.value === val);
            if (it) {
              values.push({
                value: it!.value,
                text: it!.text
              })
            }
          })
          return true
        }
        return false
      })
      if (!foundSpec) {
        addonList.some((sp) => {
          if (sp.name === item.name) {
            specName = sp.text
            item.values.map((val) => {
              const it = sp.values.find((v) => v.value === val);
              if (it) {
                values.push({
                  value: it.value,
                  text: it.text
                })
              }
            })
            return true
          }
          return false
        })
      }

      return (<><dl class="price-group__item">
        <dt>{specName}:</dt>
        <dd class="price-group__colors">
          {values.map((f, i) => (<span>{i > 0 ? ', ' : ''}<i class={{ 'price-group__highlight': item.name === props.value?.name && f.value === props.value?.value }}>{f.text}</i></span>))}
        </dd>
      </dl>
      </>)
    })

    const renderLocationMethod = (values: PriceGroupLocation[]) => values.map((item) => (<>
      {item.name && item.name.length > 0 ? (<dl class="price-group__item">
        <dt>Location:</dt>
        <dd class="price-group__colors">
          {item.name.map((f, i) => (<span>{i > 0 ? ', ' : ''}<i class={[props.type === 'location' && props.value.value === f ? 'price-group__highlight' : '']}>{f}</i></span>))}
        </dd>
      </dl>) : ''}
      {item.methods.length > 0 ? (<dl class="price-group__item">
        <dt>Method:</dt>
        <dd class="price-group__colors">
          {item.methods.map((f, i) => (<div>
            {i > 0 ? ', ' : ''}
            <i class={[props.type === 'method' && props.value.value === f.name ? 'price-group__highlight' : '']}>{getMappedMethod(f.name)}</i>
            {orderState.orderType != OrderType.SpecSample && f.minQty > 0 ? <span class="price-group__minqty">(MinQty {f.minQty})</span> : ''}
          </div>))}
        </dd>
      </dl>) : ''}
      {item.minQty ? (<span class="price-group__minqty">MinQty {item.minQty}</span>) : ''}
    </>))

    const renderCheckBox = (item: PriceGroupModel, index: number) => {
      const onCheckboxClick = (event: MouseEvent) => {
        // if (selectedIndex.value === index) {
        //   selectedIndex.value = -1
        // } else {
        //   selectedIndex.value = index
        // }
        if (item.selected) {
          item.selected = false
        }
        props.priceGroupList.forEach(f => {
          f.selected = false
        })
        item.selected = true
      }
      return (<input type="radio" role="radio" aria-checked={item.selected} class="J-group-item ui-checkbox" checked={item.selected} onClick={onCheckboxClick} />)
    }

    const renderListItem = (item: PriceGroupModel) => {
      return (<div>
        {item.specLimitation ? renderSpecLimitation(item.specLimitation) : ''}
        {item.locations && item.locations.length > 0 ? renderLocationMethod(item.locations) : ''}
      </div>)
    }
    const renderList = (priceGroupList: PriceGroupModel[]) => {
      return priceGroupList.map((item, i) => {
        return (
          <tr>
            <th>Group {i + 1}</th>
            <td>{renderListItem(item)}
              {item.youAreHere ? (<div class="you-here"><span class="txt">(you are here)</span></div>) : ''}
            </td>
            <td>
              {item.youAreHere ? '' : renderCheckBox(item, i)}
            </td>
          </tr>
        )
      })
    }
    const renderHightght = () => {
      if (props.type === 'location' || props.type === 'method') {
        const text = props.type === 'method' ? getMappedMethod(props.value?.value) : props.value?.value
        return (<div class="price-group__tips">You just select {props.type} <span class="price-group__highlight">{text}</span></div>)
      } else {
        return (<div class="price-group__tips">You just select {props.value?.name} <span class="price-group__highlight">{props.value?.value}</span></div>)
      }
    }

    const renderPriceHeader = () => (<div class="price-group__header">
      <div class="price-group__title">Do you want to change a group?</div>
      <div class="price-group__tips">* We have different groups due to pricing or imprinting limitation.</div>
      <div class="price-group__tips sec">Don't worry, you can change it back later.</div>
      {renderHightght()}
    </div>)

    const renderPriceBody = () => (
      <div class="price-group__body">
        <table class="price-group__table">
          {renderList(props.priceGroupList)}
        </table>
      </div>)

    return () => (
      <div class="price-group">
        {renderPriceHeader()}
        {renderPriceBody()}
        {renderButtons()}
      </div>)
  }
})
